import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import FormInput from '../../../components/Forms/FormInput';
import ErrorMessage from '../../../components/UI/ErrorMessage';
import LoadingSpinner from '../../../components/UI/LoadingSpinner';

const LoginForm = () => {
  	const [formData, setFormData] = useState({ 
    	username: '', 
    	password: '' 
  	});
	const [errors, setErrors] = useState({});
	const { login, loading } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

  	// Obtener la ruta desde donde venían o redirigir al dashboard
  	const from = location.state?.from?.pathname || '/dashboard';

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({ ...prev, [name]: value }));
		if (errors[name]) {
			setErrors(prev => ({ ...prev, [name]: '' }));
		}
	};

	const validateForm = () => {
		const newErrors = {};
		if (!formData.username.trim()) newErrors.username = 'El usuario es requerido';
		if (!formData.password) newErrors.password = 'La contraseña es requerida';
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		//console.log('🚀 Iniciando proceso de login...');
		
		if (!validateForm()) return;

		try {
			//console.log('📤 Enviando credenciales...');
			await login(formData);
			//console.log('✅ Login exitoso, redirigiendo a:', from);
		
			// Redirigir al dashboard después del login exitoso
			navigate(from, { replace: true });
		} catch (error) {
			//console.error('❌ Error en el login:', error);
			setErrors({ submit: error.message });
		}
	};

  	return (
    	<div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      		<div className="max-w-md w-full space-y-8">
        		<div>
					<h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
						Iniciar Sesión
					</h2>
					{/* <p className="mt-2 text-center text-sm text-gray-600">
						O{' '}
						<Link
							to="/register"
							className="font-medium text-blue-600 hover:text-blue-500"
						>
							crear una cuenta nueva
						</Link>
					</p> */}
        	</div>

			<form className="mt-8 space-y-6" onSubmit={handleSubmit}>
				<ErrorMessage error={errors.submit} />

				<div className="space-y-4">
					<FormInput
						label="Usuario"
						name="username"
						value={formData.username}
						onChange={handleChange}
						error={errors.username}
						required
						autoComplete="username"
						placeholder="Ingresa tu usuario"
					/>

					<FormInput
						label="Contraseña"
						type="password"
						name="password"
						value={formData.password}
						onChange={handleChange}
						error={errors.password}
						required
						autoComplete="current-password"
						placeholder="Ingresa tu contraseña"
					/>
				</div>

				<div>
					<button
						type="submit"
						disabled={loading}
						className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
					>
						{loading ? (
							<div className="flex items-center">
								<div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
								Iniciando sesión...
							</div>
						) : (
							'Iniciar Sesión'
						)}
					</button>
				</div>
			</form>
      	</div>
    </div>
  );
};

export default LoginForm;
